<template>
    <div>
        <h3>Costs Checker</h3>

        <div class="container">
            <label>Store <b-checkbox switch v-model="usePortal2Api" class="d-inline"/>Portal 2</label>
            <b-input type="text" v-model="invoiceDataString"></b-input>
            <b-btn @click="GetCart">Fetch</b-btn>
            <b-checkbox v-model="shouldRemoveCustomPricing">Remove Custom Pricing</b-checkbox>
        </div>

        <div class="container mt-3" v-if="invoice">
            <!-- Summation -->
            <b-card id="summation" class="col mb-3">
                <b-card-header>
                    <b-row>
                        <h2 class="col-6 d-inline">Summary</h2>
                        <span class="col-6 text-right">({{invoiceData.record_type}})</span>
                    </b-row>
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <b-col cols="8">

                        <div class="row mt-2"><span class="label">Product Sum:</span> <span>{{this.invoice.product_subtotal | currency}}</span></div>

                        <!-- SHIPPING -->
                        <div class="row">
                            <span class="label">Shipping:</span> <span>{{invoice.shipping_total | currency}}</span>
                            <small class="ml-1" v-if="invoice.shipping_total > 0">({{invoice.shipping_total / invoice.product_subtotal | percent}})</small>
                        </div>
                        <!-- TAX -->
                        <div class="row">
                            <span class="label">Tax:</span> <span>{{invoice.tax_total | currency}}</span>
                            <small class="ml-1" v-if="invoice.tax_total > 0">({{invoice.tax_total / invoice.product_subtotal | percent}})</small>
                        </div>


                        <!-- DISCOUNT -->
                        <div class="row mt-2"><span class="label">Discount Code:</span> <span>{{invoiceData.discount_code}}</span></div>
                        <div class="row">
                            <span class="label">Discount Total:</span> <span>{{invoice.discount_total | currency}}</span>
                            <small class="ml-1" v-if="invoice.discount_total > 0">({{invoice.discount_total / invoice.product_subtotal | percent}})</small>
                        </div>

                        <div class="row mt-2"><span class="label">Grand Total:</span> <span>{{invoice.subtotal + invoice.shipping_total + invoice.tax_total | currency}}</span></div>
                        <div class="row"><span class="label">Returned Total:</span> <span>{{invoice.subtotal | currency}}</span></div>
                        <div class="row"><span class="label">Commissionable:</span> <span>{{invoice.commissionable_total | currency}}</span></div>
                        <div class="row" v-if="invoice.commissionable_total > 0"><span class="label">Total-Commission:</span> <span>{{invoice.subtotal-invoice.commissionable_total | currency}}</span></div>

                        <div class="row mt-2" v-if="invoice.discount_total > 0"><span class="label">Grand - Discount:</span> <span>{{invoice.subtotal + invoice.shipping_total + invoice.tax_total - invoice.discount_total | currency}}</span></div>
                        <hr/>
                        <div v-if="invoice.discounts.length">
                            <h3>Discounts:</h3>
                            <div class="col" v-for="(discount, i) in invoice.discounts" :key="`discount_${i}`">
                                <div class="row"><span class="label">Type:</span> <span>{{discount.type}}</span></div>
                                <div class="row"><span class="label">Amnt:</span> <span>{{discount.discount_amount | currency}}</span></div>
                                <div class="row"><span class="label">New Sub:</span> <span>{{discount.subtotal_after_discount | currency}}</span></div>
                            </div>

                        </div>
                    </b-col>
                        <b-col cols="4">
                            <div class="row"><span class="label">Multiyear:</span> <span>{{invoice.multiyear}}</span></div>
                            <div class="row"><span class="label">School Year:</span><span>{{invoiceData.school_year}}</span></div>
                            <div class="row"><span class="label">Shipping Exempt:</span><span> {{invoiceData.shipping_exempt}}</span></div>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
            <div id="breakdown">
                <div class="col">
                    <!-- SHIPPING LOCATIONS -->
                    <template v-for="(shipping, j, index) in invoice.shipping">
                        <b-btn v-b-toggle="`collapse-ship-${j}`" class="border-warning text-left w-100" :style="`background-color:${colors[index % colors.length]}`">
                            Shipping Line: ({{j}}) {{shipping.address}} {{shipping.city}}, {{shipping.state}} {{shipping.zip}} -- {{shipping.subtotal | currency}}
                        </b-btn>

                        <b-collapse :id="`collapse-ship-${j}`" class="w-100">
                            <b-btn v-if="shipping.tax_response" v-b-toggle="`collapse-tax-${j}`" class="">Tax Info</b-btn>
                            <b-collapse v-if="shipping.tax_response" :id="`collapse-tax-${j}`">
                                <b-row>
                                    <b-col>
                                        Tax Source: {{shipping.tax_response.tax_source}}<br/>
                                        Has Nexus: {{shipping.tax_response.has_nexus}}<br/>
                                        Jurisdiction City: {{shipping.tax_response.jurisdictions.city}}<br/>
                                        Jurisdiction Country: {{shipping.tax_response.jurisdictions.country}}<br/>
                                        Jurisdiction County: {{shipping.tax_response.jurisdictions.county}}<br/>
                                        Jurisdiction State: {{shipping.tax_response.jurisdictions.state}}<br/><br/>
                                    </b-col>
                                    <b-col>
                                        <template v-for="(value, key) in shipping.tax_response.breakdown">
                                            <div v-if="(key != 'line_items') && value != 0">
                                                {{key | snakeToReadable}}: {{value}}
                                            </div>
                                        </template>
                                    </b-col>
                                </b-row>
                            </b-collapse>
                            <b-btn v-b-toggle="`collapse-shiplines-${j}`" class="">products</b-btn>
                            <b-collapse :id="`collapse-shiplines-${j}`" :visible="true">
                                <b-card-group  columns :key="`ship_${j}`">
                                    <!-- PRODUCT CARDS -->
                                    <b-card v-for="(product, i, index2) in shipping.products" :key="product.sku" class="product container" :style="{'background-color': colors[index2 % colors.length]}"
                                            no-body>
                                        <template #header>
                                            <h4 class="d-inline">{{product.sku}}</h4><span class="ml-1">({{product.id}})</span>
                                        </template>
                                        <b-card-body>
                                            <div><span class="label">Quantity: </span>{{product.quantity}}</div>
                                            <small class="mt-2" v-if="product.pricing_sku != product.id">{{product.pricing_sku}}</small>
                                            <small style="position:absolute;bottom:0;right:0;padding-right:5px;" class="text-black-50">{{product.format}}</small>
                                            <!-- UNIT PRICE -->
                                            <b-button v-b-toggle="`collapse-price-${j}-${i}`" class="text-left bg-transparent w-100 p-0 border-0" style="color:#212529">
                                            <span v-if="invoice.multiyear > 1">
                                                <div><span class="label">Unit Price: </span>{{product.unit_price | currency}}</div>
                                                <div><span class="label">Single Year: </span>{{product.unit_price / product.unit_price_years | currency}}</div>
                                            </span>
                                                <span v-else>
                                                <div><span class="label">Unit Price: </span>{{product.unit_price | currency}}</div>
                                            </span>
                                            </b-button>
                                            <b-collapse :id="`collapse-price-${j}-${i}`">
                                                <small><span class="label">Sku: </span>{{product.pricing_sku}}</small>
                                                <br/>
                                                <small><span class="label">Year: </span>{{product.pricing_year}}</small>
                                            </b-collapse>

                                            <!-- BASE PRICE -->
                                            <span v-if="product.unit_price < product.base_unit_price">
                                            <div class="text-strike"><span class="label">Base Price: </span>{{product.base_unit_price | currency}}</div>
                                            <div>Discount: {{((product.base_unit_price / product.unit_price) - 1) * 100 | percent}}</div>
                                        </span>

                                            <!-- SHIPPING -->
                                            <b-button v-b-toggle="`collapse-ship-${j}-${i}`" class="text-left bg-transparent w-100 p-0 border-0" style="color:#212529">
                                                <div><span class="label">Shipping: </span>{{product.shipping_cost | currency}}</div>
                                            </b-button>
                                            <b-collapse :id="`collapse-ship-${j}-${i}`">
                                                <small><span class="label">Rate: </span>{{product.shipping_rate | percent}}</small>
                                                <br/>
                                                <small><span class="label">Detail: </span>{{product.shipping_detail}}</small>
                                            </b-collapse>

                                            <!-- COMMISSION -->
                                            <b-button v-b-toggle="`collapse-coms-${j}-${i}`" class="text-left bg-transparent w-100 p-0 border-0" style="color:#212529">
                                                <div><span class="label">Com. Rate: </span>{{product.commission_rate}}</div>
                                            </b-button>
                                            <b-collapse :id="`collapse-coms-${j}-${i}`">
                                                <small><span class="label">Uncom.: </span>{{product.uncommissionable | currency}}</small>
                                            </b-collapse>

                                            <template v-if="taxesForProduct[j][product.id]">
                                                <b-button v-b-toggle="`collapse-tax-${j}-${i}`" class="bg-transparent p-0" variant="text">
                                                    <div><span class="label">Tax: </span>{{taxesForProduct[j][product.id].tax_collectable}}</div>
                                                </b-button>
                                                <b-collapse :id="`collapse-tax-${j}-${i}`">
                                                    <small>City Tax Collectable: {{taxesForProduct[j][product.id].city_amount}}</small><br/>
                                                    <small>City Tax Rate: {{taxesForProduct[j][product.id].city_tax_rate}}</small><br/>
                                                    <small>City Taxable Amount {{taxesForProduct[j][product.id].city_taxable_amount}}</small><br/>
                                                    <small>Combined Tax Rate: {{taxesForProduct[j][product.id].combined_tax_rate}}</small><br/>
                                                    <small>County Tax Collectable: {{taxesForProduct[j][product.id].county_amount}}</small><br/>
                                                    <small>County Tax Rate: {{taxesForProduct[j][product.id].county_tax_rate}}</small><br/>
                                                    <small>County Taxable Amount: {{taxesForProduct[j][product.id].county_taxable_amount}}</small><br/>
                                                    <small>Special District Collectable: {{taxesForProduct[j][product.id].special_district_amount}}</small><br/>
                                                    <small>Special District Taxable Amount: {{taxesForProduct[j][product.id].special_district_taxable_amount}}</small><br/>
                                                    <small>Special District Tax Rate {{taxesForProduct[j][product.id].special_tax_rate}}</small><br/>
                                                    <small>State Amount: {{taxesForProduct[j][product.id].state_amount}}</small><br/>
                                                    <small>State Sales Tax Rate: {{taxesForProduct[j][product.id].state_sales_tax_rate}}</small><br/>
                                                    <small>State Taxable Amount: {{taxesForProduct[j][product.id].state_taxable_amount}}</small><br/>
                                                    <small>Taxable Amount: {{taxesForProduct[j][product.id].taxable_amount}}</small><br/>
                                                </b-collapse>
                                            </template>




                                            <hr/>
                                            <div><span class="label">Subtotal: </span>{{product.unit_price * product.quantity | currency}}</div>
                                        </b-card-body>
                                    </b-card>
                                    <!-- Tester Card -->
                                    <b-card>
                                        <h5 class="d-inline">Custom</h5>
                                        <div class="mt-2"><span class="label">Unit Price: </span><b-input v-model="custom.price"></b-input></div>
                                        <div><span class="label">Quantity: </span><b-input v-model="custom.quantity"></b-input></div>
                                        <div><span class="label">Subtotal: </span><span>{{custom.price * custom.quantity | currency}}</span></div>
                                    </b-card>
                                </b-card-group>
                            </b-collapse>
                        </b-collapse>

                        <hr/>
                    </template>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "CostsChecker",
    computed: {
        invoiceData() {
            return JSON.parse(this.invoiceDataString);
        }
    },
    data: () => ({
        usePortal2Api: true,
        shouldRemoveCustomPricing: false,
        invoiceDataString: null,
        productSum: 0,
        singleYearSum: 0,
        basePriceSum: 0,
        custom: {
            price: 0,
            quantity: 1,
        },
        invoice: null,
        colors: [
            "#ef5d5d",
            "#4f6dd2",
            "#63d34b",
            "#bd3bd9",
            "#ff7c0a",
            "#f1dc06",
            "#ea59fd",
            "#9d9393",
            "#BEBD7F",
            "#B44C43",
            "#D95030",
            "#D6AE01",
            "#025669",
            "#afcea0",
            "#F39F18",
            "#7FB5B5",
            "#BDECB6",
        ],
        taxesForProduct: {}
    }),
    methods: {
        removeCustomPricing() {
            console.log("removing custom pricing");
            let data = JSON.parse(this.invoiceDataString);
            // Iterate shipping lines
            for (let key in data.shipping) {
                // Iterate products
                for (let legacyID in data.shipping[key].products) {
                    data.shipping[key].products[legacyID].custunitprice = null
                }
            }
            return data;
        },
        GetTaxResponseForItem(shipping, item) {
            if (shipping.tax_response == null)
                return null;

            for (let i = 0; i < shipping.tax_response.breakdown.line_items.length; ++i) {
                var taxRecord = shipping.tax_response.breakdown.line_items[i];
                if (taxRecord.id == item.id)
                    return taxRecord;
            }
            return null;
        },
        GetCart() {
            let data = this.invoiceData;
            if (this.shouldRemoveCustomPricing)
                data = this.removeCustomPricing();

            let url = this.usePortal2Api ? '/costs/cart_price' : '/costs/cart_discount_price';
            this.axios.post(url, data)
                .then(response => {
                    this.invoice = response.data;
                    let shipKeys = Object.keys(this.invoice.shipping);
                    let products = this.invoice.shipping[shipKeys[0]].products;
                    let productKeys = Object.keys(products);

                    this.productSum = 0;
                    this.singleYearSum = 0;
                    this.basePriceSum = 0;
                    for (let i = 0; i < productKeys.length; ++i) {
                        let product = products[productKeys[i]];
                        this.productSum += product.unit_price * product.quantity;
                        this.singleYearSum += (product.unit_price * product.quantity) / this.invoice.multiyear;
                        this.basePriceSum += product.base_unit_price * product.quantity;
                    }

                    this.invoice.product_subtotal = 0;
                    for (let key in this.invoice.shipping) {
                        let ship = this.invoice.shipping[key];
                        this.taxesForProduct[key] = {};
                        ship.subtotal = 0;
                        for (let productId in ship.products) {
                            let product = ship.products[productId];
                            let sub = product.unit_price * product.quantity;
                            ship.subtotal += sub;
                            this.invoice.product_subtotal += sub;
                            // Set unit taxes
                            let taxRecord = this.GetTaxResponseForItem(ship, product);
                            if (!taxRecord)
                                continue;

                            this.taxesForProduct[key][product.id] = taxRecord;
                        }
                    }
                })
        },

    },
    filters: {
        percent(val) {
            if (!val) return 0;
            val = parseFloat(val);
            return `%${val.toFixed(3)}`;
        },
        snakeToReadable(str) {
            return str.at(0).toUpperCase() + str.substring(1).replace(/([-_][a-z])/g, group =>
                group.toUpperCase().replace('_', ' ')
            );
        }
    },
    created() {

    }
}
</script>

<style scoped>
.label {
    font-weight: bold;
    margin-right: 5px;
}
.text-strike {
    text-decoration: line-through;
}
#breakdown .card {
}
</style>